import { EntityEditorPage, PropsFrom, SliceEntityEditorPageOnlyForExtension } from "@crispico/foundation-react";
import { CrudFormInEditor } from "@crispico/foundation-react/entity_crud/CrudFormInEditor";
import { addEntityDescriptor, EntityDescriptor, FieldDescriptor } from "@crispico/foundation-react/entity_crud/EntityDescriptor";
import { FieldRendererProps } from "@crispico/foundation-react/entity_crud/fieldRenderersEditors";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { RootReducerForPages } from "@crispico/foundation-react/reduxHelpers/RootReducerForPages";
import { FormikProps } from "formik";
import { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { Label } from "semantic-ui-react";
import { userEntityDescriptor } from "../user/userEntityDescriptor";
import { TabRouterPane } from "@crispico/foundation-react/components/TabbedPage/TabbedPage";

class UsersFieldDescriptor extends FieldDescriptor {
    constructor() {
        super();
        this.name = "recipientListToUsers";
        this.type = FieldType.oneToMany("RecipientListToUser");
        this.sortable = false;
        this.initialValue = [];
    }

    protected _getLabel = (rootReducerForPages: RootReducerForPages, item: any) => <Label horizontal>{userEntityDescriptor.toMiniString(item)}</Label>;

    renderUsers(props: FieldRendererProps, withLink: boolean = true) {
        return (<RootReducerForPages.Context.Consumer>{rootReducersForPages => props.value && props.value.map((item: any) =>
            withLink ? <NavLink key={item.user?.id} to={userEntityDescriptor.getEntityEditorUrl(item.user?.id)}>{this._getLabel(rootReducersForPages, item.user)}</NavLink> : this._getLabel(rootReducersForPages, item.user))}
        </RootReducerForPages.Context.Consumer>);
    }

    protected renderFieldInternal(RendererClass: any, props: FieldRendererProps): ReactNode {
        return this.renderUsers(props);
    }
};

export class RecipientListEntityDescriptor extends EntityDescriptor {
    constructor() {
        super({
            name: "RecipientList",
            miniFields: ["name"]
        });
    }

    protected customize() {
        this.addFieldDescriptor({ name: "id", type: FieldType.number, enabled: false })
            .addFieldDescriptor({ name: "name", type: FieldType.string })  
            .addFieldDescriptor(new UsersFieldDescriptor())
            .addFieldDescriptor({ name: "additionalEmailAddresses", type: FieldType.string })

        this.infoEditor.wrappedComponentClass = EntityEditorPageRecipientList;
    }
}


class EntityEditorPageRecipientList extends EntityEditorPage<PropsFrom<SliceEntityEditorPageOnlyForExtension>> {
    constructor(props: Readonly<PropsFrom<SliceEntityEditorPageOnlyForExtension>>) {
        super(props);
        this.editorFormSimpleClass = class extends CrudFormInEditor {
            renderFieldEditor(field: string, formikProps: FormikProps<any>): ReactNode {
                if (field === "recipientListToUsers") {
                    return <></>;
                } else {
                    return super.renderFieldEditor(field, formikProps);
                }
            }
        }
    }

    protected async onSaveInternal() {
        const ed = this.props.dispatchers.getSlice().entityDescriptor;
        await this.props.dispatchers.save(this.props.entity, undefined, 
            Object.keys(ed.fields).filter(f => ed.fields[f].enabled && !ed.fields[f].clientOnly && f !== "recipientListToUsers"),
        { componentProps: this.props });
    }

    protected getExtraTabPanes(): (TabRouterPane | null)[] {
        return [...super.getExtraTabPanes(), this.createOneToManyTabPane("RecipientListToUser", "recipientList")];
    }
}

export const RecipientListToUserEntityDescriptor = addEntityDescriptor(new EntityDescriptor({
        name: "RecipientListToUser",
        miniFields: ["recipientList.name", "user.username", "user.id"]
    })
    .addFieldDescriptor({ name: "id", type: FieldType.number, enabled: false })
    .addFieldDescriptor({ name: "recipientList", type: "RecipientList" })
    .addFieldDescriptor({ name: "user", type: "User" })
);
"../..""../../entity_crud/CrudFormInEditor""../../entity_crud/EntityDescriptor""../../entity_crud/fieldRenderersEditors""../../entity_crud/FieldType""../../reduxHelpers/RootReducerForPages""../../components/TabbedPage/TabbedPage"